export const consumInboxTags = {
     0:     
      [
        "bo_returnto_user_cir",
        "storel2_cir_forward_user",
        "uhapprv_fullissue_close",
        "uhapprv_partissue_close",
        "uhapprv_partissue_fwd",
      ],
     1:
       [
        "cosumureq_created",
        "storel2_bts_forward_bo",
        "boreq_bts_rtrned_uhlvl",
        "usereq_cir_resubmt_bo",
        "user_modified_resubmit",
        "userreq_uh_retrn_bo_mod_cir"
      ], 
     2:
        [
        "botostore_consreq_created",
        "store_bts_return_unithead",
        "boreq_bts_resubmit_uh",
        "boreq_issueallclose_forapprv",
        "userreq_fwd_bo_to_uh_store_cir",
        "boreq_parissueclse_forapprv",
        "boreq_parissue_forapprv",
        "store_bts_return_unithead"
        ],
     3:
        [
        "uhreq_bts_forward_store",
        "storel2_bts_return_l1",
        "userreq_uh_to_store_fwd_cir",
        "uh_resubmit_to_store_cir",
        "ureq_paraccept_fwd_store"
        ],
    4:     
       [
        "storel1_bts_fullissue_l2",
        "storel1_bts_partialissue_l2"
      ],
    5:
      [
        "bo_bts_accept_close"
      ]
  }